"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterProps = void 0;
var _responsiveProps = require("./responsiveProps");
const filterProps = _ref => {
  let {
    props,
    keys = [],
    responsiveKeys = []
  } = _ref;
  const filteredProps = {};
  const keysToRemove = responsiveKeys.map(_responsiveProps.responsivePropNames).reduce((acc, cur) => acc.concat(cur), []).concat(keys);
  Object.keys(props).forEach(key => {
    if (!keysToRemove.includes(key)) filteredProps[key] = props[key];
  });
  return filteredProps;
};
exports.filterProps = filterProps;